import classNames from 'classnames';
import React, { memo } from 'react';
import { playCheckboxSound } from '@wg/web2clientapi/sound';
import { ProgressCheckbox } from '@wg/wows-react-uikit';

import styles from './Building.scss';

type ILevelProps = {
  isAvailable: boolean;
  isDisabled: boolean;
  isConfirmVisible: boolean;
  isBuildingInProgress: boolean;
  isBuilt: boolean;
  isRegularIcon: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

const BuildingLevel: React.FC<ILevelProps> = ({
  isBuilt,
  isAvailable,
  isDisabled,
  isConfirmVisible,
  isBuildingInProgress,
  isRegularIcon,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  if (isBuildingInProgress || isBuilt) {
    return (
      <ProgressCheckbox
        onClick={() => {}}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        isReady={isBuilt}
        needSpacer={true}
        anchorIcon={!isRegularIcon}
      />
    );
  }

  if (isAvailable && !isDisabled) {
    return (
      <div
        className={classNames(
          styles.level,
          styles.levelAvailable,
          !isRegularIcon && styles.anchorIcon,
          isConfirmVisible && styles.levelAvailableConfirm,
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={(e) => {
          void playCheckboxSound();
          e.stopPropagation();
          if (window.tooltipProvider) {
            window.tooltipProvider.hide();
          }
          if (onClick) {
            onClick();
          }
        }}
      />
    );
  }

  return (
    <div
      className={classNames(styles.level, !isRegularIcon && styles.anchorIcon)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};

export default memo(BuildingLevel);
